module.exports = __webpack_public_path__ + "static/img/consultingCenter_5.c81b767.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/consultingCenter_5.png
// module id = wHpe
// module chunks = 1